var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarehouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.003 512.003",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    enableBackground: "new 0 0 512.003 512.003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m208.002,256.002h-16v32h-16v-32h-16c-17.672,0-32,14.328-32,32v48c0,17.672 14.328,32 32,32h48c17.672,0 32-14.328 32-32v-48c0-17.672-14.328-32-32-32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m352.002,256.002h-16v32h-16v-32h-16c-17.672,0-32,14.328-32,32v48c0,17.672 14.328,32 32,32h48c17.672,0 32-14.328 32-32v-48c0-17.672-14.328-32-32-32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m208.002,400.002h-16v32h-16v-32h-16c-17.672,0-32,14.328-32,32v48c0,17.672 14.328,32 32,32h48c17.672,0 32-14.328 32-32v-48c0-17.672-14.328-32-32-32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m352.002,400.002h-16v32h-16v-32h-16c-17.672,0-32,14.328-32,32v48c0,17.672 14.328,32 32,32h48c17.672,0 32-14.328 32-32v-48c0-17.672-14.328-32-32-32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m494.314,115.377l-224-112c-9.016-4.5-19.609-4.5-28.625,0l-224,112c-13.273,6.641-20.242,21.531-16.828,35.977 3.406,14.445 16.141,24.648 31.141,24.648v304c0,17.672 14.328,32 32,32 17.672,0 32-14.328 32-32v-256h320v256c0,17.672 14.328,32 32,32s32-14.328 32-32v-304c15,0 27.734-10.203 31.141-24.648 3.413-14.446-3.555-29.337-16.829-35.977zm-302.312,44.625h-32v-32h32v32zm96,0h-64v-32h64v32zm64,0h-32v-32h32v32z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouse);
export default __webpack_public_path__ + "static/media/warehouse.606550568fcc6a70dac61a9606593eab.svg";
export { ForwardRef as ReactComponent };